module.exports = __webpack_public_path__ + "static/media/tenzin-dai.da8c0694.jpg";